import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './CurrentDeviceCardLoading.Config.style';

const loadingConfig = theme => [
  {
    left: setLoadingConfigObject('square', 1, null, styles.deviceImage),
    main: [
      setLoadingConfigObject('line', 1, '50%', styles.firstTitle),
      setLoadingConfigObject('line', 1, '100%', styles.subtitle),
      setLoadingConfigObject('line', 1, '50%', styles.title),
      setLoadingConfigObject('line', 1, '100%', styles.subtitle),
      setLoadingConfigObject('line', 1, '50%', styles.title),
      setLoadingConfigObject('line', 1, '100%', styles.subtitle),
    ],
    style: {
      alignItems: 'flex-start',
    },
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.button),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
